import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  communitiesWrapper: {},
  tabsContent: {},
  communityAddButton: {
    minWidth: 'unset',
    fontSize: '40px',
    fontWeight: 600,
    padding: '0px 4px',
    lineHeight: '35px',
  },
}));
